<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 15h14a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v9a1 1 0 001 1zm1-2V8.5h12V13zm12-7v1.5H6V6z"/><path d="M8.75 9.5h-1.5a.5.5 0 000 1h1.5a.5.5 0 000-1zM20 18a2 2 0 00-1.93 1.5h-4.14a2 2 0 00-3.86 0H5.93a2 2 0 100 1h4.14a2 2 0 003.86 0h4.14A2 2 0 1020 18zm-8 3a1 1 0 111-1 1 1 0 01-1 1zm8 0a1 1 0 111-1 1 1 0 01-1 1z"/></svg>